<template>
    <div class="row">
        <div class="col-12" v-if="!data.length">
            <div class="no-cards d-flex justify-content-center align-middle">
                <div class="align-middle">
                    <i class="fas fa-check main-icon"></i>
                    <p class="title">{{emptyLabel[type]}}</p>
                    <a :href="routes[type]" class="btn btn-success btn-next">{{exploreBtnLabel[type]}}</a>
                </div>
            </div>
        </div>
        <template v-else v-for="item in elements">
            <item-card :resource-id="item.id" :type="type" :img-url="item.media_urls.thumb" :initial-like="item.user_like"
                       :title="!!item.title? item.title : item.occ_title" :url="getUrl(item.id,item.slug)"></item-card>
        </template>
    </div>
</template>

<script>
    // import ItemCard from "./ItemCard";
    export default {
        // components: {ItemCard},
        mounted() {
            if(this.type){
                this.elements = this.data.slice(0, 3);
            } else {
                this.elements = this.data.slice(0, 9);
            }

        },
        props: {
            type: {
                //0 recomendation occupations 1 favorite occupations 2 favorite resources
                type: Number,
                required: true,
                default: 0
            },
            data: {
                required: true,
                type: Array,
                default() {
                    return []
                }
            },
        },
        data() {
            return {
                elements: [],
                emptyLabel: [
                    "Complete your assessments to receive personalized suggestions.",
                    "Take a look the occupations and click on the heart at the top right corner to add them here.",
                    "Take a look the resources and click on the heart at the top right corner to add them here"
                ],
                exploreBtnLabel: [
                    "Go to your assessment",
                    "Explore the occupation",
                    "Explore the resources"
                ],
            }
        },
        computed: {
            routes() {
                return [
                    window.App.routes.web.assessment,
                    window.App.routes.web.jobs_index,
                    window.App.routes.web.resources_index,
                ]
            },
            redirectRoutes(){
                return [
                    window.App.routes.web.jobs_show,
                    window.App.routes.web.jobs_show,
                    window.App.routes.web.resources,
                ]
            }
        },
        methods: {
            getUrl(id, slug) {
                switch (this.type) {
                    case 0:
                        return this.redirectRoutes[this.type].replace('NUM',id)
                        break;
                    case 1:
                        return this.redirectRoutes[this.type].replace('NUM',id)
                        break;
                    case 2:
                        return this.redirectRoutes[this.type]+'/'+slug;
                        break;
                }
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/views/my_profile/ProfileBlocks.vue